import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Transfer from "./Transfer";
import PermissionDenied from "../../denied/PermissionDenied";

class TransferContainer extends Component {
  render() {
    const { permission } = this.props;
    if (!permission) {
      return <PermissionDenied />;
    }
    return <Transfer {...this.props} />;
  }
}

const mapStateProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateProps,
  mapDispatchToProps
)(withRouter(TransferContainer));
